/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { forwardRef, useEffect, useState } from 'react';
import Auth from '../../../../containers/auth';
import SearchOrder from '../../../../containers/lifeline/searchOrder';
import { UserWidget } from '../../../widgets';
import { lifelineLogo } from '../../../../images/images';
import Announcement from '../../../commons/Announcements/Announcement.js';
import { isPlayGroundMode } from '../../../../utils/CookieToken.js';
import {
  defaultOrgKey,
  ORG_ID_PARAM,
  orgBasedHeaderUIV1,
  orgIdKey,
  orgIdMapKey,
  orgValKey,
} from '../../../widgets/OrgIdDropdown/utils.js';
import { OrgIdDropdownV1 } from '../../../widgets/OrgIdDropdown/OrdIdDropdownV1.js';

export const LifelineHeaderV1 = forwardRef(function LifelineHeaderComp(
  { isAuthenticated, announcements },
  ref,
) {
  const [currentOrgId, setCurrentOrgId] = useState(
    sessionStorage.getItem(orgIdKey),
  );
  const [openUserWidget, setOpenUserWidget] = useState(false);
  const orgIdMap = JSON.parse(sessionStorage.getItem(orgIdMapKey));
  const defaultOrg = sessionStorage.getItem(defaultOrgKey);

  // useEffect to handle invalid orgId in url
  useEffect(() => {
    if (orgIdMap && !orgIdMap[currentOrgId]) {
      const orgId = defaultOrg?.id ? defaultOrg?.id : Object.keys(orgIdMap)[0];
      setCurrentOrgId(orgId);
      sessionStorage.setItem(orgIdKey, orgId);
      sessionStorage.setItem(orgValKey, orgIdMap[orgId]);
      // update the url param
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set(ORG_ID_PARAM, orgId);
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${urlParams}`,
      );
    }
  }, [orgIdMap, currentOrgId]);

  useEffect(() => {
    setCurrentOrgId(sessionStorage.getItem(orgIdKey));
  }, [sessionStorage.getItem(orgIdKey)]);

  return (
    <>
      <div
        className={`tw-w-full tw-py-5 tw-px-7 tw-flex tw-justify-between tw-items-center fixedHeader ${
          isPlayGroundMode
            ? 'tw-bg-yellow-400'
            : orgBasedHeaderUIV1[currentOrgId]?.backgroundColor
        } `}
        css={`
          box-shadow: 0px 1px 10px 0px rgba(28, 28, 28, 0.06);
        `}
        ref={ref}
      >
        {/* Org Name Header */}

        {isPlayGroundMode ? (
          <div className='tw-w-96  tw-flex  tw-h-full tw-items-center tw-justify-center'>
            <div className=' tw-flex tw-items-baseline tw-gap-1'>
              <span className='tw-text-900 tw-font-extrabold'>
                {orgIdMap?.[currentOrgId] ??
                  defaultOrg?.name ??
                  (orgIdMap ? Object.values(orgIdMap)[0] : '')}
              </span>
              <span className='tw-text-800 tw-font-medium'>Playground</span>
            </div>
          </div>
        ) : (
          <>
            {currentOrgId ? (
              orgBasedHeaderUIV1[currentOrgId]?.logo
            ) : (
              <div className='tw-w-72 tw-h-12'>
                <img
                  src={lifelineLogo}
                  alt='blinkit lifeline'
                  width='100%'
                  height='100%'
                />
              </div>
            )}
          </>
        )}

        {/* Search Component */}
        <div className='tw-flex tw-w-1/2'>
          <SearchOrder />
        </div>

        {/* Org and User Profile Dropdowns */}
        <div className='tw-flex tw-gap-4 tw-justify-end tw-h-full'>
          <div className='tw-flex tw-w-[15rem] tw-h-full'>
            <OrgIdDropdownV1 />
          </div>
          {isAuthenticated ? (
            <div
              onClick={() => {
                setOpenUserWidget((prev) => !prev);
              }}
              className={`tw-px-6 tw-py-4 tw-border-solid  tw-border-[1px] ${
                currentOrgId == 3 ||
                currentOrgId == 1 ||
                isPlayGroundMode ||
                !currentOrgId
                  ? 'tw-border-grey-400/80 !tw-bg-grey-100/40'
                  : 'tw-border-white'
              } tw-rounded-xl tw-bg-base-white/[0.24] tw-flex tw-items-center  tw-justify-center tw-cursor-pointer`}
            >
              <UserWidget
                openUserWidget={openUserWidget}
                setOpenUserWidget={setOpenUserWidget}
              />
            </div>
          ) : (
            <Auth />
          )}
        </div>
      </div>
      {isAuthenticated && announcements && announcements.length ? (
        <Announcement announcements={announcements} />
      ) : null}
    </>
  );
});
